import gql from "graphql-tag";

export const CheckoutProps = gql`
  fragment CheckoutProps on Checkout {
    id
    totalPrice
    totalBonus
    subtotalPrice
    discounts {
      notes {
        type
        note
      }
      discountApplication {
        code
        description
      }
    }
    customAttributes {
      key
      value
    }
    shippingLine {
      price
    }
    shippingAddress {
      id
      address1
    }
    availableShippings {
      id
      slug
      price
      name
      description
      latitude
      longitude
    }
    availablePayments {
      id
      name
      description
    }
    lineItems {
      id
      name
      quantity
      price
      priceCompareAt
      customAttributes {
        id
        key
        value
      }
      variant {
        id
        image {
          id
          url
        }
        price
        priceCompareAt
        metafields {
          key
          value
        }
        selectedOptions {
          name
          value
        }
        name
        weight
        weightUnit
        product {
          name
          slug
          collections {
            slug
            siblings {
              id
            }
          }
        }
      }
      customAttributes {
        key
        value
      }
    }
    iikoBonusesAdd
    iikoBonusesUse
  }
`;

export const GET_CHECKOUT = gql`
  query getCheckout($id: ID!) {
    checkout(where: { id: $id }) {
      ...CheckoutProps
    }
  }
  ${CheckoutProps}
`;

export const CHECKOUT_COMPLETED = gql`
  query checkoutCompleted($id: ID!) {
    checkout(where: { id: $id }) {
      id
      completed
    }
  }
`;

export const GET_CHECKOUT_WITH_PAYMENT = gql`
  query getCheckoutWithPayment(
    $checkout: CheckoutWhereUniqueInput!
    $payment: PaymentProviderWhereUniqueInput!
  ) {
    getTotalSumByPayment(checkout: $checkout, payment: $payment) {
      ...CheckoutProps
    }
  }
  ${CheckoutProps}
`;

export const CREATE_CHECKOUT = gql`
  mutation createCheckout($data: CheckoutCreateInput!) {
    createCheckout(data: $data) {
      id
    }
  }
`;

export const UPDATE_CHECKOUT = gql`
  mutation updateCheckout($checkoutId: ID!, $data: CheckoutUpdateInput!) {
    updateCheckout(checkout: { id: $checkoutId }, data: $data) {
      ...CheckoutProps
    }
  }
  ${CheckoutProps}
`;

export const COMPLETE_CHECKOUT = gql`
  mutation completeCheckout($checkoutId: ID!, $paymentId: ID!) {
    completeCheckoutWithPayment(
      checkout: { id: $checkoutId }
      payment: { provider: { id: $paymentId } }
    ) {
      payment {
        id
        url
      }
      checkout {
        ...CheckoutProps
      }
    }
  }
  ${CheckoutProps}
`;
